import React from "react";

function Header() {
    return (
        // <div className="bg-masters-green bg-opacity-50">
        <div className="bg-black bg-opacity-30">
            <p className="text-5xl pt-10 masters-label">2024 Masters Pool</p>
            <p className="text-2xl pb-10 masters-label">( Final Results )</p>
        </div>
    );
};

export default Header;